<!--
 * @Author: cjh
 * @LastEditors: Du Feng
 * @Date: 2022-01-11 11:38:33
 * @LastEditTime: 2023-01-31 14:55:30
 * @Description: Modify here please
-->
<template>
  <div>
    <div class="detail">
      <div class="header">
        <div class="left" @click="toIndex()">< 返回</div>
        <div class="span1">
          <span>课酬明细</span>
        </div>
        <div class="right"></div>
      </div>
      <div class="main">
        <!-- <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="学校教师" name="schoolTear"> </el-tab-pane>
          <el-tab-pane label="校外人员" name="schoolOut"> </el-tab-pane>
        </el-tabs>
        <el-form :inline="true" :model="queryParams" label-width="70px">
          <el-form-item label="">
            <el-input
              v-model="queryParams.a"
              placeholder="请输入学校名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="">
             <el-input
              v-model="queryParams.b"
              placeholder="请输入姓名"
            ></el-input>
          </el-form-item>
          <el-form-item label="" style="margin-left: 20px">
            <el-button type="primary" size="small" @click="searchFun()"
              >搜索</el-button
            >
          </el-form-item>
        </el-form> -->
        <div class="table_import">
          <el-table :data="tableData" style="width: 100%" border>
            <el-table-column
              prop="name"
              label="姓名"
              align="center"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="job"
              :label="activeName=='schoolTear'?'学校':'所属单位'"
              align="center"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="a"
              label="课程数"
              align="center"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="b"
              label="课时总数"
              align="center"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="c"
              label="实到课时数"
              align="center"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="d"
              label="应结课酬"
              align="center"
              show-overflow-tooltip
            >
            </el-table-column>
          </el-table>
          <div class="pagination">
            <el-pagination
              background
              :current-page="pageNum"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pageSize"
              :total="totalPage"
              layout="total,prev, pager, next,jumper,sizes"
              @size-change="sizeChangeHandle"
              @current-change="currentChangeHandle"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { handleMaterialsDetail } from "@/api/mechanismApi/curriculum.js";
export default {
  props: [],
  components: {},
  data() {
    return {
      activeName: "schoolTear",
      pageNum: 1,
      pageSize: 10,
      totalPage: 10,
      tableData: [
        {name:'  丁雨',job:'实验小学',a:'1',b:'45',c:'44',d:'¥1,760.00'},
        {name:'林佳惠',job:'第七小学',a:'2',b:'24',c:'24',d:'¥960.00'},
        {name:'张运杰',job:'第一小学',a:'2',b:'24',c:'24',d:'¥960.00'},
        {name:'周绮琴',job:'第二实验',a:'3',b:'30',c:'29',d:'¥1,160.00'},
        {name:'赵才良',job:'回族小学',a:'2',b:'44',c:'44',d:'¥1,760.00'},
        {name:'孙彦君',job:'回族小学',a:'1',b:'23',c:'23',d:'¥920.00'},
        {name:'李怀薇',job:'实验小学',a:'3',b:'22',c:'22',d:'¥880.00'},
        {name:'陈令婧',job:'第一小学',a:'3',b:'50',c:'46',d:'¥1,840.00'},
        {name:'陈采萱',job:'实验小学',a:'1',b:'24',c:'24',d:'¥960.00'},
        {name:'栾乐欣',job:'回族小学',a:'2',b:'45',c:'45',d:'¥1,800.00'},
      ],
      queryParams: {
        a: "",
        b: "",
      },
    };
  },
  computed: {},
  watch: {
    info: {
      async handler(n, o) {
      },
      deep: true,
    },
  },
  created() {},
  methods: {
    toIndex() {
      this.$emit("to-index");
    },
    handleClick(tab, event) {
      this.activeName = tab.name;
      if(this.activeName=='schoolTear'){
         this.tableData=[ 
        {name:'  丁雨',job:'实验小学',a:'1',b:'45',c:'44',d:'¥1,760.00'},
        {name:'林佳惠',job:'第七小学',a:'2',b:'24',c:'24',d:'¥960.00'},
        {name:'张运杰',job:'第一小学',a:'2',b:'24',c:'24',d:'¥960.00'},
        {name:'周绮琴',job:'第二实验',a:'3',b:'30',c:'29',d:'¥1,160.00'},
        {name:'赵才良',job:'回族小学',a:'2',b:'44',c:'44',d:'¥1,760.00'},
        {name:'孙彦君',job:'回族小学',a:'1',b:'23',c:'23',d:'¥920.00'},
        {name:'李怀薇',job:'实验小学',a:'3',b:'22',c:'22',d:'¥880.00'},
        {name:'陈令婧',job:'第一小学',a:'3',b:'50',c:'46',d:'¥1,840.00'},
        {name:'陈采萱',job:'实验小学',a:'1',b:'24',c:'24',d:'¥960.00'},
        {name:'栾乐欣',job:'回族小学',a:'2',b:'45',c:'45',d:'¥1,800.00'},]
      }else{
         this.tableData=[ 
        {name:'王婷',  job:'课程之家',a:'2',b:'34',c:'34',d:'¥1,190.00'},
        {name:'杨辉翔',job:'欧美思	',a:'1',b:'18',c:'18',d:'¥630.00'  },
        {name:'王龙',  job:'课程之家',a:'3',b:'19',c:'19',d:'¥665.00'  },
        {name:'谢瑾瑜',job:'欧美思	',a:'1',b:'29',c:'29',d:'¥1,015.00'},
        {name:'黄震宇',job:'果力教育',a:'2',b:'27',c:'27',d:'¥945.00'},
        {name:'李相余',job:'智位科技',a:'1',b:'21',c:'20',d:'¥700.00'  },
        {name:'王昊',  job:'智课	',a:'1',b:'25',c:'25',d:'¥875.00'  },
        {name:'李东升',job:'欧美思	',a:'3',b:'26',c:'26',d:'¥910.00'},
        {name:'冯刚浩',job:'果力教育',a:'3',b:'26',c:'26',d:'¥910.00 '  },
        {name:'彭玉芳',job:'智位科技',a:'3',b:'28',c:'28',d:'¥980.00'},]
      }
    },
    async getDataList() {
    //   let params = {
    //     pageNum: this.pageNum,
    //     pageSize: this.pageSize,
    //     cid: this.info.cid,
    //     orgName: this.queryParams.orgName,
    //     introduceState: this.queryParams.introduceState,
    //   };
    //   let res = await educationApi.getCourseOrgintroduce(params);
    //   if (res.result == "000000") {
    //     this.tableData = res.data?.list || [];
    //     this.totalPage = res.data?.total || 0;
    //   }
    },
    searchFun() {
      this.pageNum = 1;
      this.getDataList();
    },
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.getDataList();
    },
    currentChangeHandle(val) {
      this.pageNum = val;
      this.getDataList();
    },
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
.detail {
  width: 100%;
  padding: 0px 30px 30px 30px;
  .header {
    height: 60px;
    line-height: 48px;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .span1 {
      font-family: "PingFang SC Bold";
      font-size: 20px;
      color: #000;
      margin-right: 30px;
    }
    .left,
    .right {
      width: 60px;
    }
    .left {
      cursor: pointer;
    }
  }
  .main {
    width: 100%;
    height: 100%;
    .main-title {
      display: flex;
      align-items: center;
      p {
        font-weight: bold;
        font-size: 14px;
        color: #181c26;
        margin-left: 10px;
      }
    }
    .main-li {
      margin-top: 20px;
      width: 100%;
      display: flex;
      // align-items: center;
      font-size: 14px;
      color: #888;
      p {
        width: 120px;
        text-align: right;
        margin-right: 20px;
      }
      span {
        width: calc(100% - 150px);
        word-wrap: break-word;
      }
    }
    .coverAreas {
      display: flex;
      margin-top: 20px;
      width: 100%;
      font-size: 14px;
      color: #888;
      .coverAreas_right {
        width: 120px;
        text-align: right;
        margin-right: 20px;
      }
      .coverAreas_left {
        width: 200px;
        word-wrap: break-word;
        p {
          width: 500px;
          margin-bottom: 10px;
        }
      }
    }
  }

  .table {
    width: 100%;
    margin-top: 30px;
    border: 1px solid #eee;
    .td-1 {
      width: 30%;
      height: 100%;
      float: left;
    }
    .td-2 {
      width: 70%;
      height: 100%;
      float: right;
    }
    .file {
      display: flex;
      align-items: center;
      justify-content: space-between;
      div {
        display: flex;
        align-items: center;
        img {
          margin-right: 20px;
        }
        span {
          width: 200px;
          text-align: left;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      a {
        font-size: 14px;
        line-height: 48px;
        color: #4991e1;
        margin-right: 20px;
      }
    }
    li {
      display: inline-block;
      width: 50%;
      height: 48px;
      text-align: center;
      font-size: 14px;
      line-height: 48px;
      color: #7a8da2;
      position: relative;
    }
    .table-header {
      width: 100%;
      height: 48px;
      background: #fafafa;
      border: 1px solid #eee;
      display: flex;
      div {
        height: 100%;
        text-align: center;
        font-size: 14px;
        line-height: 48px;
        color: #7a8da2;
      }
    }
  }
  .table_2_tr {
    width: 100%;
    height: 48px;
    font-size: 14px;
    line-height: 48px;
    color: #7a8da2;
    text-align: center;
  }

  .handle-item {
    width: 100%;
    height: 50px;
    margin-top: 20px;
    font-size: 14px;
    display: flex;
    align-items: flex-start;
    padding-left: 80px;
    position: relative;
    .line {
      position: absolute;
      width: 1px;
      height: calc(100% + 10px);
      background: #eeeeee;
      left: 90px;
      top: calc(50% - 5px);
    }
    .handle-title {
      width: 50%;
      margin-left: 15px;
      .text {
        color: #888;
      }
    }
    .handle-name {
      min-width: 120px;
      text-align: right;
    }
    .handle-time {
      margin-left: 20px;
      color: #888;
    }
  }

  .price-box {
    display: flex;
    align-items: center;
    margin-top: 30px;
    span {
      width: 80px;
      color: #888;
    }
    ::v-deep .el-input__inner {
      height: 32px;
    }
  }
}

.info_header {
  display: flex;
  align-items: center;
  padding-bottom: 20px;
  .info_header_item {
    img {
      height: 80px;
      max-width: 500px;
    }
    div {
      margin: 15px;
    }
  }
}
::v-deep .el-tabs__nav {
  height: 45px !important;
  margin-top: 10px !important;
}
.video-class {
  max-width: 300px;
}
footer {
  margin-top: 50px;
  display: flex;
  justify-content: center;
}
.pagination {
  text-align: center;
  margin-top: 30px;
}
</style>
